export enum TenantStatus {
  Fetching,
  Exists,
  DoesNotExist,
  Error,
}
